import { Button, Pagination } from 'flowbite-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const Events = () => {
  const pastInfluencers = [
    { name: 'John Doe', agency: 'HellYes', position: 'Supervisor', price: '$500', contract: '12 Months' },
    { name: 'Jane Smith', agency: 'Pearl Lemon Leads', position: 'Manager', price: '$300', contract: '6 Months' },
    { name: 'Alex Green', agency: 'Aquare', position: 'Director', price: '$200', contract: '3 Months' },
    { name: 'Emma Brown', agency: 'CHS', position: 'Supervisor', price: '$700', contract: '24 Months' },
    { name: 'Nancy Wheeler', agency: 'Intellibright', position: 'Manager', price: '$400', contract: '9 Months' }
  ];

  const [currentPageInfluencers, setCurrentPageInfluencers] = useState(1);
  const itemsPerPageInfluencers = 3;
  const indexOfLastInfluencer = currentPageInfluencers * itemsPerPageInfluencers;
  const indexOfFirstInfluencer = indexOfLastInfluencer - itemsPerPageInfluencers;
  const currentInfluencers = pastInfluencers.slice(indexOfFirstInfluencer, indexOfLastInfluencer);
  const totalPagesInfluencers = Math.ceil(pastInfluencers.length / itemsPerPageInfluencers);

  const handlePageChangeInfluencers = (page) => {
    setCurrentPageInfluencers(page);
  };

  const initialPromotions = [
    { name: 'John Doe', agency: 'HellYes', position: 'Supervisor', price: '$500', contract: '12 Months' },
    { name: 'Jane Smith', agency: 'Pearl Lemon Leads', position: 'Manager', price: '$300', contract: '6 Months' },
    { name: 'Alex Green', agency: 'Aquare', position: 'Director', price: '$200', contract: '3 Months' },
    { name: 'Emma Brown', agency: 'CHS', position: 'Supervisor', price: '$700', contract: '24 Months' },
    { name: 'Nancy Wheeler', agency: 'Intellibright', position: 'Manager', price: '$400', contract: '9 Months' }
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [currentPagePromotions, setCurrentPagePromotions] = useState(1);
  const itemsPerPagePromotions = 3;

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortOrder(order);
  };

  const sortedPromotions = [...initialPromotions]
    .filter(promo =>
      promo.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      promo.position.toLowerCase().includes(searchTerm.toLowerCase()) ||
      promo.agency.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const aValue = a[sortColumn].toLowerCase();
      const bValue = b[sortColumn].toLowerCase();
      if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });

  const indexOfLastPromotion = currentPagePromotions * itemsPerPagePromotions;
  const indexOfFirstPromotion = indexOfLastPromotion - itemsPerPagePromotions;
  const currentPromotions = sortedPromotions.slice(indexOfFirstPromotion, indexOfLastPromotion);
  const totalPagesPromotions = Math.ceil(sortedPromotions.length / itemsPerPagePromotions);

  const handlePageChangePromotions = (page) => {
    setCurrentPagePromotions(page);
  };

  return (
    <>
      <SEO
        title="Film Industry Events"
        description="Browse and track upcoming film industry events, festivals, and networking opportunities on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/events"
        robots="noindex, nofollow"
      />
      <SubNav />
      <div className="bg-white min-h-screen p-4 space-y-12">
        {/* Header Section */}
        <section className="text-center py-10 p-3 bg-blue-600 text-white">
          <h1 className="text-4xl font-bold">Event Promotions</h1>
          <p className="mt-4 text-lg">Grow your brand with high-visibility ad campaigns</p>
        </section>

        {/* Promotions Table Section */}
        <section className="max-w-7xl mt-3 mx-auto">
          <div className="mb-8 flex justify-between items-center">
            <input
              type="text"
              placeholder="Search by Name or Position or Agency..."
              value={searchTerm}
              onChange={handleSearch}
              className="p-3 border border-gray-300 rounded-lg w-72"
            />
            <Button onClick={() => handleSort(sortColumn)} className="bg-blue-600 text-white">
              Sort by {sortColumn.charAt(0).toUpperCase() + sortColumn.slice(1)}
            </Button>
          </div>

          <div className="overflow-x-auto mt-3 shadow-md rounded-lg">
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th onClick={() => handleSort('name')} className="cursor-pointer p-3 text-left">Name {sortColumn === 'name' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => handleSort('agency')} className="cursor-pointer p-3 text-left">Agency {sortColumn === 'agency' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => handleSort('position')} className="cursor-pointer p-3 text-left">Position {sortColumn === 'position' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => handleSort('price')} className="cursor-pointer p-3 text-left">Price {sortColumn === 'price' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => handleSort('contract')} className="cursor-pointer p-3 text-left">Contract {sortColumn === 'contract' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                  <th className="p-3"></th>
                </tr>
              </thead>
              <tbody>
                {currentPromotions.map((promo, index) => (
                  <tr key={index} className="border-t">
                    <td className="p-3">{promo.name}</td>
                    <td className="p-3"><Link to='/company' className="hover:underline">{promo.agency}</Link></td>
                    <td className="p-3">{promo.position}</td>
                    <td className="p-3">{promo.price}</td>
                    <td className="p-3">{promo.contract}</td>
                    <td className="p-3">
                      <Link to='/connect'>
                        <Button className="bg-yellow-400">Connect</Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex justify-center mt-4">
            <Pagination
              currentPage={currentPagePromotions}
              totalPages={totalPagesPromotions}
              onPageChange={handlePageChangePromotions}
            />
          </div>
        </section>

        {/* Past Collaborations Section */}
        <section className="mt-12 p-4">
          <h2 className="text-2xl font-bold mb-4">Past Collaborations</h2>
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Agency</th>
                <th className="p-3 text-left">Position</th>
                <th className="p-3 text-left">Price</th>
                <th className="p-3 text-left">Contract</th>
                <th className="p-3"></th>
              </tr>
            </thead>
            <tbody>
              {currentInfluencers.map((influencer, index) => (
                <tr key={index} className="border-t">
                  <td className="p-3">{influencer.name}</td>
                  <td className="p-3"><Link to='/company' className="hover:underline">{influencer.agency}</Link></td>
                  <td className="p-3">{influencer.position}</td>
                  <td className="p-3">{influencer.price}</td>
                  <td className="p-3">{influencer.contract}</td>
                  <td className="p-3">
                    <Button className="bg-yellow-400">View</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-center mt-4">
            <Pagination
              currentPage={currentPageInfluencers}
              totalPages={totalPagesInfluencers}
              onPageChange={handlePageChangeInfluencers}
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default Events;

